import React from 'react';
import { Button, Popconfirm } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/authSlice';
import { RootState, AppDispatch } from '../store/store';

export const LogoutButton: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const handleLogout = () => {
    // Clear access code from localStorage
    localStorage.removeItem('auth_access_code');
    
    // Clear auth state in Redux
    dispatch(logout());
  };

  // Don't render if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="logout-button-container">
      <Popconfirm
        title="Logout"
        description="Are you sure you want to logout?"
        onConfirm={handleLogout}
        okText="Yes, Logout"
        cancelText="Cancel"
        okType="danger"
      >
        <Button
          danger
          icon={<LogoutOutlined />}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Logout
        </Button>
      </Popconfirm>
    </div>
  );
};